<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">
              Cloudflare Enterprise Domains
            </h4>
          </div>
          <div class="card-body pt-0">
            <div class="row pb-10">
              <div class="col-md-2">
                <label class="d-flex align-items-center"> Show
                  <select id="grouped"
                          v-model="pageMainSize"
                          aria-describedby="grouped"
                          class="mr-7 ml-7 custom-select custom-select-sm form-control form-control-sm datatable-dropdown"
                          required style="width: 65px;">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option :value="sortedDomains.length">All</option>
                  </select> entries</label>
              </div>
              <div class="col-md-8"></div>
              <div class="col-md-2 pull-left">
                <input v-model="searchQuery" class="form-control mr-5" placeholder="Search" style="height: 30px;"
                       type="text"/>
              </div>
            </div>
            <div v-if="loading" class="loader small_loader"></div>
            <table v-else-if="!loading" id="datatable" class="table table-striped table-bordered">
              <thead>
              <tr>
                <th width="5%"></th>
                <th width="10%">Domain</th>
                <th class="text-center" width="8%">Server IP</th>
                <th class="text-center" width="10%">Plan</th>
                <th class="text-center" width="20%">Note</th>
                <th class="text-center" width="5%">Is Activated</th>
                <th class="text-center" width="5%">O20 Status</th>
                <th class="text-center" width="5%">Activated At</th>
                <th class="text-center" width="32%">Action</th>
              </tr>
              </thead>
              <tbody v-for="(row, index) in paginatedDomains" :key="row.id">
              <tr :class="{'warning-bg': row.cfEnterprise.status === 'pending' || row.cfEnterprise.status === 'running'}">
                <td>
                  <span
                      :class="{ 'details-control shown' : openDetails === row.id, 'details-control' : openDetails !== row.id }"
                      @click="openDetails === row.id ? openDetails = null : openDetails = row.id"></span>
                </td>
                <td>
                  {{ row.domain }}
                </td>
                <td class="text-center" width="10%">
                  {{ row.ip || '' }}
                </td>
                <td width="20%">
                  <template>
                    <div class="d-flex align-items-center">
                      <select v-model="row.cfPlan" class="form-control">
                        <option value="performance_package">Performance Package</option>
                        <option disabled value="security_package">Security Package</option>
                        <option value="performance_and_security_package">Performance & Security Package</option>
                        <option value="boost">Boost</option>
                        <option disabled value="maintenance_I">Maintenance I</option>
                        <option disabled value="maintenance_II">Maintenance II</option>
                        <option disabled value="maintenance_III">Maintenance III</option>
                        <option value="mediavine_integration">Mediavine Integration</option>
                      </select>
                      <span><i class="fa fa-save text-primary ml-10 make-cursor-pointer"
                               title="Save"
                               @click="selectedIndex = index; action='changePlan';setCFPlanInHostingAccounts(row, true)"></i><i
                          v-if="index === selectedIndex && action === 'changePlan'"
                          class="fa fa-spinner fa-spin text-primary ml-10 make-cursor-pointer"></i></span>
                    </div>

                  </template>
                </td>
                <td class="make-cursor-pointer" style="max-width: 20px" @click="openModal(row)">
                  <span>{{ row.cfEnterprise && row.cfEnterprise.note ? row.cfEnterprise.note : 'N/A' }}</span></td>
                <td class="text-center fs-16">
                  <i :class="row.cfEnterprise.status === 'pass' || row.cfEnterprise.previousStatus === 'pass' ? 'fa fa-check-circle text-success' : (row.cfEnterprise.status === 'running' ? 'fa fa-spinner fa-spin text-info' : (row.cfEnterprise.status === 'fail' ? 'fa fa-exclamation-circle text-warning' : 'fa fa-times-circle text-danger'))"
                     :title="(row.cfEnterprise.status === 'fail') ? 'One or more steps have failed during the setup process.' : ''"></i>
                </td>
                <td class="text-center fs-16">
                  <i :class="row.cfEnterprise.o2o_status ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'"></i>
                </td>
                <td class="text-center">
                  {{
                    row.cfEnterprise.activatedAt === 'Not enabled by WPO' ? 'Activation Date Not Available' : parseDate(row.cfEnterprise.activatedAt)
                  }}
                </td>
                <td class="text-center" width="16%">
                  <button v-if="row.cfEnterprise.status === 'pending'" class="btn btn-sm btn-warning mr-5"
                          title="Initialise process" @click="initiatePKeyProcess(row, index)">
                    <span v-if="action === 'initPKey' && selectedIndex === index"><i class="fa fa-spinner fa-spin"></i></span>
                    <span v-else><i class="fa fa-flash make-cursor-pointer"></i></span>
                  </button>
                  <button class="btn btn-sm btn-primary" title="View Output" @click="viewLogs(row.cfEnterprise)">
                    <span><i class="fa fa-eye make-cursor-pointer"></i></span>
                  </button>
                  <button class="btn btn-primary btn-sm ml-2" title="Login as user" @click="loginAsUser(row, index)">
                    <i class="fa fa-user"></i>
                  </button>
                  <button v-if="row.cfEnterprise.status === 'fail'" class="btn btn-sm btn-info ml-5"
                          title="Retry" @click="retry(row, index)">
                    <span v-if="action === 'retry' && selectedIndex === index"><i
                        class="fa fa-spinner fa-spin"></i></span>
                    <span v-else><i class="fa fa-repeat make-cursor-pointer"></i></span>
                  </button>
                  <button class="btn btn-sm btn-danger ml-5" title="Deactivate CF Enterprise"
                          @click="deactivate(row, index)">
                    <span v-if="action === 'deactivate' && selectedIndex === index"><i
                        class="fa fa-spinner fa-spin"></i></span>
                    <span v-else><i class="fa fa-trash make-cursor-pointer"></i></span>
                  </button>
                  <button v-if="row.cfEnterprise.status === 'pass'" class="btn btn-sm btn-default grey ml-5"
                          title="Change O2O status" @click="change020Status(row, index)">
                    <span v-if="action === 'changeO2O' && selectedIndex === index"><i class="fa fa-spinner fa-spin"></i></span>
                    <span v-else>O2O</span>
                  </button>
                </td>
              </tr>
              <tr v-if="row.id === openDetails" class="bg-primary-light">
                <td colspan="9">
                  <section v-if="!row.cfEnterprise.steps">
                    <b v-if="row.cfEnterprise.previousStatus && row.cfEnterprise.previousStatus === 'pass'"
                       class="fw-500">This domain
                      seems to have Cloudflare Enterprise already. Possibly, it was here under a different Cloudflare
                      plan but the new service came through a different name. In this case, if you click on 'Activate'
                      button, WPO will NOT run the script to setup Cloudflare Enterprise again but it will just update
                      the CF Plan name.</b>
                    <b v-else>The setup process has not been initialized yet.</b>
                  </section>
                  <section v-else>
                    <div class="row text-left">
                      <div class="col-md-12">
                        <h6><b>Initialized By: {{ row.cfEnterprise.initializedBy || 'WPO' }}</b></h6>
                      </div>
                    </div>
                    <div>
                      <table class="table">
                        <thead>
                        <tr>
                          <th class="text-left">
                            <div class="text-left"><b>Step</b></div>
                          </th>
                          <th width="10%"><b>Status</b></th>
                          <th width="50%"><b>Responses</b></th>
                        </tr>
                        </thead>
                        <tbody>
                        <!-- Loop through cfEnterprise.steps -->
                        <tr v-for="(el, key) in sortedSteps(row.cfEnterprise.steps)" :key="key">
                          <td class="text-left">
                            <div class="text-left">{{ el.text }}</div>
                          </td>
                          <td width="10%">
                            <span>
                              <i :class="el.status === 'pass' ? 'fa fa-check-circle text-success' : (el.status === 'pending' ? 'fa fa-spinner fa-spin text-info' : (el.status === 'fail' ? 'fa fa-exclamation-circle text-warning' : 'fa fa-times-circle text-danger'))"></i>
                            </span>
                          </td>
                          <td class="text-center" width="50%">
                            <div class="text-left">
                              <!-- Show data in a JSON string or format as needed -->
                              <div v-if="viewResponce === `${row.id + key}`" class="json-container">
                                <pre v-if="el.data">
                                  {{ JSON.stringify(el.data, null, 2) }}
                                </pre>
                                <div v-else>
                                  We do not have stored responses for older data.
                                </div>
                              </div>
                              <div style="display: flex; justify-content: space-between">
                                <div>
                                  <a class="make-cursor-pointer text-primary"
                                     @click.prevent="viewResponce === `${row.id + key}` ? viewResponce = null : viewResponce = `${row.id + key}`">
                                    {{ viewResponce === `${row.id + key}` ? "Hide" : "View" }}
                                  </a>
                                  <span v-if="el.status === 'fail'" class="mx-2">|</span>
                                  <a v-if="el.status === 'fail'" class="make-cursor-pointer text-primary"
                                     @click.prevent="resolveForcefully(row, el.key)">
                                    Resolve Forcefully
                                  </a>
                                </div>
                                <div v-if="el.resolvedForcefully" style="font-size: 13px">
                                  <i>{{ el.resolvedForcefully }}</i>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="row text-left">
                      <div class="col-md-12">
                        <h6><b>Status-Check</b></h6>
                      </div>
                    </div>
                    <div>
                      <table class="table">
                        <thead>
                        <tr>
                          <th class="text-left">
                            <div class="text-left"><b>Step</b></div>
                          </th>
                          <th width="10%"><b>Status</b></th>
                          <th width="50%"><b>Responses</b></th>
                        </tr>
                        </thead>
                        <tbody>
                        <!-- Loop through cfEnterprise.steps -->
                        <tr v-for="(el, status_index) of statuses" :key="status_index">
                          <td class="text-left">
                            <div class="text-left">{{ el.text }}</div>
                          </td>
                          <td width="10%">
                            <span>
                              <i v-if="sloader === `${row.id}`" class="fa fa-spinner fa-spin text-info"></i>
                              <i v-else
                                 :class="row.cfEnterprise[el.key] === 'active' ? 'fa fa-check-circle text-success' :'fa fa-exclamation-circle text-warning'"
                                 :title="row.cfEnterprise[el.key]"></i>
                            </span>
                          </td>
                          <td class="text-center" width="50%">
                            <div class="text-left">
                              <!-- Show data in a JSON string or format as needed -->
                              <div v-if="viewResponce === `${row.id + el.key}`" class="json-container">
                                <pre v-if="row.cfEnterprise.checkStatuseResponse">
                                  {{ JSON.stringify(row.cfEnterprise.checkStatuseResponse, null, 2) }}
                                </pre>
                                <div v-else>
                                  We do not have stored responses for older data.
                                </div>
                              </div>
                              <div style="display: flex; justify-content: space-between">
                                <div>
                                  <a class="make-cursor-pointer text-primary"
                                     @click.prevent="viewResponce === `${row.id + el.key}` ? viewResponce = null : viewResponce = `${row.id + el.key}`">
                                    {{ viewResponce === `${row.id + el.key}` ? "Hide" : "View" }}
                                  </a>
                                  <!--                                 v-if="!row.cfEnterprise[el.key] || row.cfEnterprise[el.key] !== 'active'" -->
                                  <span class="mx-2">|</span>
                                  <a class="make-cursor-pointer text-primary"
                                     @click.prevent="recheckStatus(row, `${row.id}`)">
                                    Re-Check
                                  </a>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </section>
                </td>
              </tr>
              </tbody>
            </table>
            <template v-if="!sortedDomains.length">
              <div class="row">
                <div class="col-md-12 text-center text-danger mb-3 font-weight-bold">
                  No Domain Exists
                </div>
              </div>
            </template>
            <div v-if="sortedDomains.length > 0 " class="row mt-10">
              <div class="col-md-12 d-flex justify-content-between">
                    <span class="lh-3 pull-left">
                       <b>Page {{ pageMainNum + 1 }} of {{ mainPageCount }}</b>
                    </span>
                <section class="dataTables_paginate paging_full_numbers">
                  <paginate
                      id="notes"
                      :clickHandler="goToMainPage"
                      :nextText="'Next'"
                      :pageCount="mainPageCount"
                      :prevText="'Prev'"
                      containerClass="pagination"
                      next-class="page-item"
                      next-link-class="page-link"
                      page-class="page-item"
                      page-link-class="page-link"
                      prev-class="page-item"
                      prev-link-class="page-link">
                  </paginate>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="view-log-modal">
      <div id="viewLogsModal" aria-hidden="true" class="modal fade" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title text-center">Log Details</h6>
              <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <section v-if="selectedLog.history !== undefined" class="mt-5">
                <!--                <code>-->
                <table class="table notesTable">
                  <thead>
                  <tr>
                    <th class="text-center">Output</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Activated At</th>
                    <th class="text-center">Deactivated At</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, index) in sortedHistory" :key="'note_' + index">
                    <td class="text-center" style="word-break: break-all" width="40%">{{ row.output }}</td>
                    <td class="text-center">
                      <span
                          :class="{'badge-success': row.status === 'pass', 'badge-danger': row.status === 'fail', 'badge-warning': row.status === 'removed'}"
                          class="badge">{{
                          row.status === 'pass' ? 'Activated' : (row.status === 'fail' ? 'Fail' : (row.status === 'removed' ? 'Deactivated' : ''))
                        }}</span>
                    </td>
                    <td class="text-center">
                      {{ row.activatedAt === 'N/A' ? 'Not enabled by WPO' : parseDate(row.activatedAt) }}
                    </td>
                    <td class="text-center">{{ parseDate(row.deactivatedAt) }}</td>
                  </tr>
                  </tbody>
                </table>
                <div v-if="selectedLog.history.length > 0 " class="row mt-10">
                  <div class="col-md-12 d-flex justify-content-between">
                    <span class="lh-3 pull-left">
                       <b>Page {{ pageNum + 1 }} of {{ pageCount }}</b>
                    </span>
                    <section class="dataTables_paginate paging_full_numbers">
                      <paginate
                          id="notes"
                          :clickHandler="goToPage"
                          :nextText="'Next'"
                          :pageCount="pageCount"
                          :prevText="'Prev'"
                          containerClass="pagination"
                          next-class="page-item"
                          next-link-class="page-link"
                          page-class="page-item"
                          page-link-class="page-link"
                          prev-class="page-item"
                          prev-link-class="page-link">
                      </paginate>
                    </section>
                  </div>
                </div>
                <!--                </code>-->
              </section>
              <code v-else>
                <ol style="list-style: none">
                  <li>{{ selectedLog.output }}</li>
                </ol>
              </code>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" data-dismiss="modal" type="button">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <activate-c-f-modal ref="activeCfModal"/>

  </div>
</template>

<script>
import moment from "moment";
import {db} from "@/firebase/init";
import swal from 'sweetalert2';
import Paginate from 'vuejs-paginate'
import ActivateCFModal from "@/components/Admin/Tasks/activateCFModal.vue";
import {getOrderedHostingDocs, isMultiDocUser} from '@/utils/firestoreUtils';

export default {
  name: "enterprise",
  components: {ActivateCFModal, Paginate,},
  computed: {
    user() {
      return this.$store.getters.user;
    },
    pageCount() {
      if (this.selectedLog && this.selectedLog.history && this.selectedLog.history.length > 0) {
        let filteredGroups = this.selectedLog.history
        let l = filteredGroups.length, s = this.pageSize;
        return Math.ceil(l / s);
      }
    },
    mainPageCount() {
      if (this.sortedDomains && this.sortedDomains.length > 0) {
        let filteredGroups = this.sortedDomains
        let l = filteredGroups.length, s = this.pageMainSize;
        return Math.ceil(l / s);
      }
    },
    sortedHistory() {
      if (!this.selectedLog.history) {
        return []
      }
      const start = this.pageNum * this.pageSize, end = start + this.pageSize;
      const allTasks = this.selectedLog.history.slice(start, end);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return allTasks.sort((a, b) => new Date(b.activatedAt) - new Date(a.activatedAt))
      // return this.selectedLog.history ? this.selectedLog.history.sort((a, b) => new Date(b.activatedAt) - new Date(a.activatedAt)) : []
    },
    paginatedDomains() {
      const start = this.pageMainNum * this.pageMainSize, end = start + this.pageMainSize;
      const allTasks = this.sortedDomains.slice(start, end);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return allTasks
    },
    sortedDomains() {
      let domains = this.domains
      if (this.searchQuery) {
        domains = domains.filter(el => (el.domain && el.domain.includes(this.searchQuery.trim())) || (el.cfEnterprise.activatedAt && el.cfEnterprise.activatedAt.includes(this.searchQuery.trim())))
      }
      // const notActivatedByWPO =JSON.parse( JSON.stringify(domains.filter(el => el.cfEnterprise.activatedAt === 'Not enabled by WPO')));
      // const activatedByWPO = JSON.parse( JSON.stringify(domains.filter(el => el.cfEnterprise.activatedAt !== 'Not enabled by WPO')));
      // // console.log('sorted', this.domains.sort((a, b) => new Date(a.activatedAt) - new Date(b.activatedAt)))
      // const data = activatedByWPO.sort((a, b) => {
      //   if ('activatedAt' in a.cfEnterprise && 'activatedAt' in b.cfEnterprise) {
      //     return new Date(b.cfEnterprise.activatedAt) - new Date(a.cfEnterprise.activatedAt);
      //   } else if ('activatedAt' in a.cfEnterprise) {
      //     // If 'a' has 'activatedAt' and 'b' doesn't, 'a' comes before 'b'
      //     return -1;
      //   } else if ('activatedAt' in b.cfEnterprise) {
      //     // If 'b' has 'activatedAt' and 'a' doesn't, 'b' comes before 'a'
      //     return 1;
      //   } else {
      //     // If neither 'a' nor 'b' has 'activatedAt', maintain the original order
      //     return 0;
      //   }
      // }).concat(notActivatedByWPO);
      if (this.initial) {
        return domains.sort((a, b) => {
          const statusA = a.cfEnterprise.status;
          const statusB = b.cfEnterprise.status;

          // Compare indices in the statusOrder array
          return this.statusOrder.indexOf(statusA) - this.statusOrder.indexOf(statusB);
        });
      } else {
        return domains
      }
    }
  },
  data() {
    return {
      showItUID: 'KHLq1RjrpMT7aV0JY9fy2yrcYvT2',
      action: '',
      initial: true,
      searchQuery: '',
      loading: false,
      activeLoading: false,
      domains: [],
      selectedLog: {output: '',},
      listener: null,
      pageNum: 0,
      pageSize: 3,
      pageMainNum: 0,
      pageMainSize: 10,
      selectedIndex: -1,
      openDetails: null,
      viewResponce: null,
      sloader: null,
      statusOrder: ['pending', 'fail', 'running', 'pass'],
      statuses: [{
        key: 'ssl_status',
        text: 'SSL Status'
      }, {
        key: 'hostname_status',
        text: 'Hostname Status'
      }, {
        key: 'update_canonical_dns',
        text: 'Update Canonical DNS'
      }],
    }
  },
  beforeDestroy() {
    if (this.listener) {
      this.listener()
    }
  },
  watch: {
    searchQuery(newValue) {
      this.searchQuery = newValue.replace(/\s/g, '');
    }
  },
  mounted() {
    this.loading = true
    this.fetchActivatedCfEnterpriseDomains()
    this.loading = false
  },
  methods: {
    async loginAsUser(data) {
      const domainRef = await db.collection('domains')
          .where('domain', '==', data.domain)
          .where('ip', '==', data.ip)
          .limit(1).get()
      let domainInfo = null
      if (domainRef.size > 0) {
        domainRef.forEach(el => {
          domainInfo = {id: el.id, ...el.data()}
        })
        console.log(domainInfo)
        window.open(`https://wpo.bigscoots.com/user/dashboard?id=${domainInfo.uid}`, 'WPO-Bigscoots');
      } else {
        swal('Error!', 'User not found!', 'error');
      }
    },
    openModal(data) {
      this.$emit('openModal', data);
    },
    async recheckStatus(row, key) {
      this.sloader = key
      try {
        await this.$http.post("provider/recheck-statuses", {
          grant_type: "token",
          docId: row.id,
        })
      } catch (e) {
        console.log('e', e.toString())
      }
      this.sloader = null
    },
    async resolveForcefully(row, key) {
      const {cfEnterprise} = row
      if (cfEnterprise.steps[key]) {
        cfEnterprise.steps[key].status = 'pass'
        cfEnterprise.steps[key].resolvedForcefully = `Resolved Forcefully by ${this.user.firstName} ${this.user.lastName}`;
      }
      const allSteps = Object.values(cfEnterprise.steps);
      const allSucceeded = allSteps.every(s => s.status === 'pass');
      const anyFailed = allSteps.some(s => s.status === 'fail');

      cfEnterprise.status = anyFailed ? 'fail' : allSucceeded ? 'pass' : 'running';
      cfEnterprise.activated = allSucceeded;
      cfEnterprise.activatedAt = allSucceeded ? new Date().toISOString() : '';
      await db.collection('domains')
          .doc(row.id)
          .update({
            cfEnterprise
          });
    },
    sortedSteps(steps) {
      // Convert steps to an array, sort by `seq`, and return it
      return Object.entries(steps)
          .sort(([, a], [, b]) => a.seq - b.seq) // Sort by the `seq` property
          .map(([key, value]) => ({...value, key})); // Add the key back
    },
    renderDatatable() {
      console.log('rendering')
      if ($.fn.DataTable.isDataTable('#datatable')) {
        $("#datatable").DataTable().destroy();
      }
      $("#datatable").DataTable({
        ordering: false,
        retrieve: true,
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search",
          emptyTable: "No domain exists",
          size: '40'
        }
      });
    },
    goToPage(pageNum) {
      this.pageNum = pageNum - 1;
    },
    goToMainPage(pageNum) {
      this.pageMainNum = pageNum - 1;
    },
    viewLogs(log) {
      console.log(log);
      this.selectedLog = log;
      if (this.selectedLog.history) {
        this.selectedLog.history = this.selectedLog.history.reverse()
      }
      this.pageNum = 0;
      this.pageSize = 3;
      /* eslint-disable */
      $("#viewLogsModal").modal("show");
      $(document).ready(function () {
        $(".modal-backdrop").appendTo(".view-log-modal");
      });
      /* eslint-enable */
    },
    parseDate(date) {
      if (!date) {
        return null
      }
      return moment(date).format('DD MMM YYYY, hh:mm a')
    },
    async getCFData(row) {
      try {
        const docsToFetch = isMultiDocUser(row.uid)
            ? await getOrderedHostingDocs(row.uid)
            : [db.collection('hostingAccounts').doc(row.uid)];

        const apiData = {};

        for (const docRef of docsToFetch) {
          const ref = await docRef.get();
          if (!ref.exists) continue;

          const {accounts} = ref.data();

          for (const acc of accounts) {
            if (acc.primary.domain === row.domain) {
              apiData.email = acc.primary.cloudflare.username || '';
              apiData.apikey = acc.primary.cloudflare.apiKey || '';
              return apiData;
            }

            for (const addon of acc.addon) {
              if (addon.domain === row.domain) {
                apiData.email = acc.primary.cloudflare.username || '';
                apiData.apikey = acc.primary.cloudflare.apiKey || '';
                return apiData;
              }
            }
          }
        }

        return apiData;

      } catch (e) {
        console.log('error while fetching data', e.toString());
      }
    },
    async setCFPlanInHostingAccounts(data, from = false, changeStatus = false) {
      this.initial = false;
      try {
        if (!data.cfPlan) {
          swal('Error', 'Please select CF Plan first', 'error');
          this.selectedIndex = -1;
          this.action = '';
          return false;
        }

        const docsToFetch = isMultiDocUser(data.uid)
            ? await getOrderedHostingDocs(data.uid)
            : [db.collection('hostingAccounts').doc(data.uid)];

        for (const docRef of docsToFetch) {
          const ref = await docRef.get();
          if (ref.exists) {
            const {accounts} = ref.data();

            for (const row of accounts) {
              // Match domain and server IP
              if (row.primary.domain === data.domain && row.primary.serverIP === data.ip) {
                row.primary.cloudflarePlan = data.cfPlan === 'mediavine_integration'
                    ? ['mediavine_integration']
                    : data.cfPlan;
                break;
              }

              const obj = row.addon.find(
                  el => el.domain === data.domain && row.primary.serverIP === data.ip
              );

              if (obj) {
                obj.cloudflarePlan = data.cfPlan === 'mediavine_integration'
                    ? ['mediavine_integration']
                    : data.cfPlan;
              }
            }

            await docRef.update({accounts});
          }
        }

        if (changeStatus) {
          data.cfEnterprise.status = 'pass';
        }

        if (data.cfPlan !== 'mediavine_integration') {
          const response = await this.$http.post('/hostingAccounts/change-route-register-for-mediavine', {
            id: data.id,
            domain: data.domain,
            integrations: 'none',
            grant_type: 'token'
          });
          console.log(response);
        }

        await db.collection('domains').doc(data.id).update({
          cfPlan: data.cfPlan,
          cfEnterprise: data.cfEnterprise
        });

        if (from) {
          this.action = '';
          this.selectedIndex = -1;
          swal('Success', 'Plan has been changed successfully', 'success');
        }

      } catch (e) {
        this.action = '';
        this.selectedIndex = -1;
        console.log('error while setting CF plan data', e.toString());
      }
    },
    async deactivate(row, index) {
      this.initial = false
      this.action = 'deactivate';
      this.selectedIndex = index;
      try {
        const apiData = await this.getCFData(row)
        let buttonHtml = '<div>' +
            '<div>Are you sure you want to deactivate Cloudflare Enterprise with following details? </div>' +
            '<br/>' +
            '<ul class="list-inline">' +
            `<li><b>Domain:</b> ${row.domain}</li>` +
            `<li><b>IP:</b> ${row.ip}</li>` +
            `<li><b>CF Email:</b> ${apiData.email}</li>` +
            `<li><b>CF API Key:</b> ${apiData.apikey}</li>` +
            // '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Primary + Addons</button></li>' +
            // '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
            '</ul></div>'
        const result = await swal({
          title: "Deactivate Cloudflare Enterprise!",
          html: buttonHtml,
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        })
        if (result.value) {
          // this.loading = true;
          const response = await this.$http.post("provider/deactivate_cf_enterprise", {
            grant_type: "token",
            domain: row.domain,
            email: apiData.email || '',
            apiKey: apiData.apikey || '',
            ip: row.ip
          })
          console.log('response', response.data)
          const domainRef = await db.collection('domains').doc(row.id).get()
          // await this.fetchActivatedCfEnterpriseDomains();
          row.cfEnterprise = domainRef.data().cfEnterprise
          await this.setCFPlanInHostingAccounts({...row, cfPlan: 'free'})
          swal('Success', 'You have successfully deactivated CF Enterprise for ' + row.domain, 'success');
        }
        this.loading = false;
      } catch (e) {
        this.loading = false
        console.log('74', e.toString())
        swal('Error', 'Something went wrong while deactivating CF Enterprise', 'error');
      } finally {
        this.action = '';
        this.selectedIndex = -1;
      }
    },
    async change020Status(row, index) {
      this.initial = false
      const flag = row.cfEnterprise.o2o_status ? 'disabled' : 'enabled';
      this.action = 'changeO2O';
      this.selectedIndex = index;
      swal({
        title: "Are you sure?",
        html: `Please note, O2O Status will be set to ${flag}.<br>Would you like to proceed?`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      }).then(async (result) => {
        if (result.value) {
          swal({
            title: "Processing...",
            html: "Please wait while we update the status.",
            allowOutsideClick: false,
            showConfirmButton: false,
            onOpen: () => {
              swal.showLoading();
            }
          });

          const status = row.cfEnterprise.o2o_status ? row.cfEnterprise.o2o_status : false;

          try {
            await this.$http.post("provider/change_o2o_status", {
              grant_type: "token",
              status: !status,
              domainData: row,
              domainId: row.id,
              hostingAccountId: row.uid
            });

            // Close loading alert
            swal.close();

            // Show success message
            await swal({
              title: "Success",
              html: `O2O has been ${flag} for <b>${row.domain}</b>`,
              type: "success",
            });
          } catch (error) {
            // Close loading alert and show error if any
            swal.close();
            swal({
              title: "Error",
              text: "Something went wrong. Please try again.",
              type: "error"
            });
          }
        }
      });
      this.action = '';
      this.selectedIndex = -1;

    },
    async retry(data, index) {
      this.initial = false
      this.action = 'retry';
      this.selectedIndex = index;
      try {
        console.log('1231', data)
        const apiData = await this.getCFData(data);
        let buttonHtml = '<div>' +
            '<div>Are you sure you want to deactivate Cloudflare Enterprise with following details? </div>' +
            '<br/>' +
            '<ul class="list-inline">' +
            `<li><b>Domain:</b> ${data.domain}</li>` +
            `<li><b>IP:</b> ${data.ip}</li>` +
            `<li><b>CF Email:</b> ${apiData.email}</li>` +
            `<li><b>CF API Key:</b> ${apiData.apikey}</li>` +
            '</ul></div>'
        const result = await swal({
          title: "Activate Cloudflare Enterprise!",
          html: buttonHtml,
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        })
        if (result.value) {
          console.log('api data', apiData);
          // const domainRef = await db.collection('domains').where('domain', '==', data.domain).where('ip', '==', data.ip).limit(1).get();
          // if(domainRef.size) {
          //   const {id} = domainRef.docs[0];
          //   const cfEnterprise = domainRef.docs[0].data().cfEnterprise || {}
          //   cfEnterprise.status = 'running'
          //   await db.collection('domains').doc(id).update({cfEnterprise});
          //
          // }
          const response = await this.$http.post("provider/initiate_cf_pkey", {
            grant_type: "token",
            domain: data.domain,
            username: apiData.email,
            apiKey: apiData.apikey,
            ip: data.ip,
            docId: data.id,
            initializedBy: `${this.user.firstName} ${this.user.lastName}`
          })
          console.log('response', response)
        }
      } catch (e) {
        console.log('error at 1266', e.toString())
        swal('Error', 'Something went wrong while processing of activating CF Enterprise', 'error');
      } finally {
        this.loading = false;
        this.action = '';
        this.selectedIndex = -1;
      }
    },
    async fetchActivatedCfEnterpriseDomains() {
      try {
        this.loading = true;
        this.domains = []
        this.listener = await db.collection('domains').where('cfEnterprise.status', 'in', this.statusOrder).onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(changeDoc => {
            if (changeDoc.type === 'added') {
              this.domains.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
            }
            if (changeDoc.type === 'modified') {
              // this.domains = this.domains.filter(el => el.id !== changeDoc.doc.id)
              const selectedDomain = this.domains.find(el => el.id === changeDoc.doc.id)
              selectedDomain.cfEnterprise = {...changeDoc.doc.data().cfEnterprise}
              // this.domains.push({id: changeDoc.doc.id, ...changeDoc.doc.data(), openDetails: false})
            }
            if (changeDoc.type === 'removed') {
              this.domains = this.domains.filter(el => el.id !== changeDoc.doc.id)
            }
          });
        });
        console.log('70', this.domains, this.domains.length)
        console.log('im calling again')
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        this.loading = false;
      } catch (e) {
        this.loading = false
        console.log('74', e.toString())
      } finally {
      }
    },
    async initiatePKeyProcess(row, index) {
      this.initial = false;
      this.activeLoading = row.id;
      this.action = 'initPKey';
      this.selectedIndex = index;

      try {
        console.log(`row ${JSON.stringify(row)}`);

        // Step 1: Set CF Plan
        await this.setCFPlanInHostingAccounts(row, false, row.cfEnterprise.previousStatus === 'pass');

        // Step 2: If previously passed, skip
        if (row.cfEnterprise.previousStatus === 'pass') {
          if (row.cfPlan === 'mediavine_integration') {
            try {
              const response = await this.$http.post('/hostingAccounts/change-route-register-for-mediavine', {
                id: row.id,
                domain: row.domain,
                integrations: row.planName.toLowerCase().includes('journey') ? 'journey' : (row.planName.toLowerCase().includes('mediavine') ? 'mediavine' : 'none'),
                grant_type: 'token'
              })
              console.log('response of update integration', response.data)
            } catch (e) {
              console.log('error while updating integration', e.toString())
            }
          }
          return
        }


        let taskInfo = row;

        // Step 3: Get hosting account documents
        const docsToFetch = isMultiDocUser(row.uid)
            ? await getOrderedHostingDocs(row.uid)
            : [db.collection('hostingAccounts').doc(row.uid)];

        for (const docRef of docsToFetch) {
          const hostingAccountRef = await docRef.get();
          if (!hostingAccountRef.exists) continue;

          const {accounts} = hostingAccountRef.data();

          const obj = accounts.find(
              el =>
                  el.primary.domain === row.domain ||
                  !!el.addon.find(adon => adon.domain === row.domain)
          );

          if (obj) {
            if (obj.primary.domain === row.domain) {
              taskInfo = {...taskInfo, ...obj.primary};
            } else {
              const addon = obj.addon.find(el => el.domain === row.domain);
              if (addon) {
                addon.serverIP = obj.primary.serverIP;
                taskInfo = {...taskInfo, ...addon};
              }
            }
            break; // Found the account, no need to continue
          }
        }

        // Step 4: Send initiation request
        await this.$http.post('provider/initiate_cf_pkey', {
          grant_type: 'token',
          username: taskInfo.cloudflare.username || '',
          apiKey: taskInfo.cloudflare.apiKey || '',
          docId: row.id,
          initializedBy: `${this.user.firstName} ${this.user.lastName}`,
        });

      } catch (e) {
        console.log('Error:', e.toString());
      } finally {
        this.activeLoading = false;
        this.action = '';
        this.selectedIndex = -1;
      }
    }
  }
}
</script>

<style scoped>
code {
  background: #f4f4f4;
  border: 1px solid #ddd;
  border-left: 3px solid #2954fa;
  color: #666;
  page-break-inside: avoid;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.6;
  margin-bottom: 1.6em;
  max-width: 100%;
  overflow: auto;
  padding: 1em 1.5em;
  display: block;
  word-wrap: break-word;
}

code .info {
  color: #376c4f;
}

code .danger {
  color: #cf363e;
}

.grey {
  opacity: 0.9;
}

.warning-bg {
  background-color: #fff9cb !important;
}

.bg-primary-light {
  background-color: #dbdbdb !important;
}


.details-control {
  background: url('../../../assets/img/details_open.png') no-repeat center center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: block;
  margin: 13px auto;
}

.details-control.shown {
  background: url('../../../assets/img/details_close.png') no-repeat center center;
}

tr > th, td {
  padding: 4px 7px !important;
  text-align: center !important;
}

tr > th {
  font-size: 12px !important;
  font-weight: 400 !important;
}

.pagination {
  display: inline-flex !important;
}

.json-container {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-family: monospace;
  white-space: pre-wrap !important; /* Preserve line breaks for readability */
  word-wrap: break-word !important; /* Avoid overflow */
  max-width: 500px;
  overflow-wrap: break-word !important;
  overflow-x: auto;
}
</style>

